import { TabStyles } from '@tableau/widgets';

export const body: React.CSSProperties = {
	paddingLeft: TabStyles.Spacing.LargeSpace
};

export const warning: React.CSSProperties = {
	fontSize: TabStyles.Typography.Sizing.Large,
	fontWeight: 'bolder',
	paddingBottom: TabStyles.Spacing.SmallSpace
};

export const prefix: React.CSSProperties = {
	fontWeight: 'bold',
	paddingLeft: TabStyles.Spacing.MediumSpace
};

export const containerWrapper: React.CSSProperties = {
	paddingBottom: TabStyles.Spacing.LargeSpace,
};

export const checkbox: React.CSSProperties = {
	paddingTop: TabStyles.Spacing.MediumSpace,
};

export const inlineAlert: React.CSSProperties = {
	paddingTop: '10px',
};
